(() => {
  const initialise = (scope = document) => {
    scope.querySelectorAll('[data-uk-packs]').forEach((widget) => {
      if (widget.dataset.ready) return;
      let data;
      try { data = JSON.parse(widget.querySelector('[data-uk-pack-data]').textContent); } catch { return; }
      if (!data.packs['2'].length || !data.packs['3'].length) return;
      widget.dataset.ready = 'true';
      const section = widget.closest('[data-uk-product]');
      const prices = section.querySelectorAll('.uk-price');
      const buttons = [...widget.querySelectorAll('[data-uk-pack-size]')];
      const selects = [...widget.querySelectorAll('[data-uk-pack-style]')];
      const add = widget.querySelector('[data-uk-pack-add]');
      const buy = widget.querySelector('[data-uk-pack-buy]');
      const errorBox = widget.querySelector('[data-uk-pack-error]');
      const choices = widget.querySelector('[data-uk-pack-choices]');
      const money = (pence) => new Intl.NumberFormat('en-GB', { style: 'currency', currency: data.currency }).format(pence / 100);
      const root = data.root.endsWith('/') ? data.root : data.root + '/';
      let size = [1, 2, 3].includes(Number(widget.dataset.initialPack)) ? Number(widget.dataset.initialPack) : 1;
      let chosen;
      let busy = false;
      section.classList.add('uk-has-packs');
      const quantity = section.querySelector('[data-uk-quantity-input]');
      if (quantity) quantity.value = '1';
      const initialStyle = section.dataset.selectedStyle;
      if (initialStyle && data.images[initialStyle]) selects[0].value = initialStyle;
      const update = () => {
        section.classList.toggle('uk-pack-active', size > 1);
        choices.hidden = size === 1;
        buttons.forEach((button) => button.setAttribute('aria-pressed', String(Number(button.dataset.ukPackSize) === size)));
        selects.forEach((select, index) => {
          widget.querySelector('[data-uk-pack-row="' + (index + 1) + '"]').hidden = index >= size;
          const photo = widget.querySelector('[data-uk-pack-photo="' + (index + 1) + '"]');
          photo.src = data.images[select.value];
          photo.alt = data.labels.photo.replace('__STYLE__', select.value);
        });
        errorBox.hidden = true;
        if (size === 1) {
          prices.forEach((element) => { element.textContent = money(data.singlePrice); });
          return;
        }
        const styles = selects.slice(0, size).map((select) => select.value);
        chosen = data.packs[String(size)].find((variant) => variant.options.every((style, i) => style === styles[i]));
        add.disabled = busy || !chosen?.available;
        if (buy) buy.disabled = busy || data.preview || !chosen?.available;
        add.textContent = chosen?.available ? data.labels.add.replace('__COUNT__', size).replace('__PRICE__', money(chosen.price)) : data.labels.unavailable;
        if (chosen) {
          prices.forEach((element) => { element.textContent = money(chosen.price); });
          widget.querySelector('[data-uk-pack-saving]').textContent = data.labels.saving.replace('__AMOUNT__', money(data.singlePrice * size - chosen.price)).replace('__COUNT__', size);
        }
      };
      buttons.forEach((button) => button.addEventListener('click', () => {
        if (busy || section.dataset.ukPurchaseBusy) return;
        const previousSize = size;
        size = Number(button.dataset.ukPackSize);
        const currentStyle = section.dataset.selectedStyle;
        if (previousSize === 1 && currentStyle && data.images[currentStyle]) selects[0].value = currentStyle;
        update();
      }));
      selects.forEach((select) => select.addEventListener('change', () => { if (!section.dataset.ukPurchaseBusy) update(); }));
      const purchase = async (event) => {
        const button = event.currentTarget;
        const direct = button === buy;
        if (busy || section.dataset.ukPurchaseBusy || window.TELUKCartUI?.isBusy() || button.disabled || !chosen?.available || (direct && data.preview)) return;
        const variantId = chosen.id;
        const controls = [...section.querySelectorAll('button, select, input')].map((element) => ({ element, disabled: element.disabled }));
        busy = true; section.dataset.ukPurchaseBusy = 'true';
        controls.forEach(({ element }) => { element.disabled = true; });
        errorBox.hidden = true;
        add.textContent = data.labels.adding;
        try {
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || data.labels.error);
          if (window.TELUKCartUI) await window.TELUKCartUI.afterLashesAdded(button, direct);
          else if (direct) window.location.assign(root + 'checkout');
          else {
            const bagButton = document.querySelector('[data-uk-open-bag]');
            if (bagButton) bagButton.click(); else window.location.assign(root + 'cart');
          }
        } catch (error) {
          errorBox.textContent = error.message || data.labels.error;
          errorBox.hidden = false;
        } finally {
          busy = false; delete section.dataset.ukPurchaseBusy;
          controls.forEach(({ element, disabled }) => { element.disabled = disabled; });
          add.disabled = !chosen?.available;
          add.textContent = chosen?.available ? data.labels.add.replace('__COUNT__', size).replace('__PRICE__', money(chosen.price)) : data.labels.unavailable;
        }
      };
      add.addEventListener('click', purchase);
      buy?.addEventListener('click', purchase);
      update();
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', (event) => initialise(event.target));
})();


